import type { FieldError } from "@av/components/atoms/form/types";
import { i18nInstance } from "@av/config/i18n/i18n-bundle";

import type { ApiErrorCode } from "../../admin-settings/type";
import type { TFunction } from "i18next";

const getErrorCodeMapping = (t: TFunction) => {
  return {
    NotBlank: {
      priority: 0,
      i18nTemplate: "platform.common.validation_required",
      i18nParams: {},
      label: t("platform.common.validation_required"),
    },
    NotNull: {
      priority: 1,
      i18nTemplate: "platform.common.validation_required",
      i18nParams: {},
      label: t("platform.common.validation_required"),
    },
    NotEmpty: {
      priority: 2,
      i18nTemplate: "platform.common.validation_required",
      i18nParams: {},
      label: t("platform.common.validation_required"),
    },
    Email: {
      priority: 3,
      i18nTemplate: "platform.common.validation_invalidEmail",
      i18nParams: {},
      label: t("platform.common.validation_invalidEmail"),
    },
    Unique: {
      priority: 4,
      i18nTemplate: "platform.adminSettings.users_actionMessage_duplicateEmail",
      i18nParams: {},
      label: t("platform.adminSettings.users_actionMessage_duplicateEmail"),
    },
    LastUserPermissionsEditor: {
      priority: 5,
      i18nTemplate: "platform.adminSettings.users_actionMessage_lastUserPermissionsEditor",
      i18nParams: {},
      label: t("platform.adminSettings.users_actionMessage_lastUserPermissionsEditor"),
    },
    LastAtsUserPermissionsEditor: {
      priority: 6,
      i18nTemplate: "platform.adminSettings.users_actionMessage_lastAtsUserPermissionsEditor",
      i18nParams: {},
      label: t("platform.adminSettings.users_actionMessage_lastAtsUserPermissionsEditor"),
    },
  } as const;
};

export function getDisplayedError(
  t: TFunction,
  code: ApiErrorCode,
  serverParams?: Record<string, string | number | boolean | string[]>
): FieldError {
  const mappedErrorCode = getErrorCodeMapping(t)[code];

  if (!mappedErrorCode) {
    console.error("Error code mapping not found");

    return { i18nTemplate: "hr.common.validation_unknown", i18nParams: { code } };
  }

  return {
    i18nTemplate: mappedErrorCode.i18nTemplate,
    i18nParams: {
      ...mappedErrorCode.i18nParams,
      ...serverParams,
    },
    priority: mappedErrorCode.priority,
  };
}

export const ERROR_CODE_I18N_MAPPING = getErrorCodeMapping(i18nInstance.t);
